export default __webpack_public_path__ + "95fd1a92cbc3cc139f68c0aab4432781.ply";